module.exports = window["MaterialUI"].TablePagination;